import { api } from "../utils/axios";

interface UserPayload {
  name?: string;
  currentCity?: string;
  about?: string;
  email: string;
  token: string;
}

export const upsertUser = async (payload: UserPayload) => {
  const { token, ...userData } = payload;

  const response = await api.post("/api/users", userData, {
    withCredentials: true,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};
export const getProfile = async (
  page: number = 1,
  limit: number = 10,
  photosLimit: number = 12,
  token: string
) => {
  try {
    const response = await api.get(`/api/users/profile`, {
      params: { page, limit, photosLimit },
      withCredentials: true,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching user profile:", error);
    throw error;
  }
};

export const saveMultipleRestaurants = async (
  restaurantIds: string[],
  token: string
) => {
    try {
    const response = await api.post(
      "/api/users/save-multiple",
      { restaurantIds },
      {
        withCredentials: true,
        headers: {
        Authorization: `Bearer ${token}`,
      },
     }
    )
    return response.data;
   } catch (error) {
        console.error("Error saving multiple restaurants:", error);
        throw error;
    }
}

export const uploadToRestaurant = async (
  restaurantId: string,
  file: File,
  token: string
) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await api.post(
      `/api/users/upload/${restaurantId}/photos`,
      formData,
      {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data", 
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error uploading photo:", error);
    throw error;
  }
};

